import Footer from "./UI/Footer";

export default Footer